module.exports = __webpack_public_path__ + "media/emojis/happy-7918d9db.svg";